module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-07.c9aa607f.png";